// @flow

import _ from 'lodash';
import { Fields, type FieldProps } from 'redux-form';
import cx from 'classnames';
import React, { PureComponent } from 'react';

import { isValidName } from 'client/utils/validate';
import { renderTextInput } from 'client/components/form/helpers';
import RequiredField from 'client/components/form/requiredField';
import Translate from 'client/components/translate';

export const firstNameFieldName = 'first_name';
export const lastNameFieldName = 'last_name';

type ValidatorsType = Array<Function>;

type PlaceholderPropType = {
  firstName: string,
  lastName: string,
};

type Props = {
  validators: ValidatorsType,
  fieldNames: Array<string>,
  changeHandler: Function,
  placeholder: PlaceholderPropType,
  noLabelAnimate: boolean,
};

class FirstAndLastGroup extends PureComponent<Props> {
  static defaultProps = {
    validators: [],
    fieldNames: [firstNameFieldName, lastNameFieldName],
    changeHandler: () => {},
    placeholder: {},
    noLabelAnimate: false,
  };

  nameValidator = (val: string) => (isValidName(val) ? undefined : { path: 'common.error.name' });

  firstNameValidators: ValidatorsType = this.props.validators
    .filter(v => v.fieldName === this.props.fieldNames[0])
    .map(v => v.validator)
    .concat(this.nameValidator);

  lastNameValidators: ValidatorsType = this.props.validators
    .filter(v => v.fieldName === this.props.fieldNames[1])
    .map(v => v.validator)
    .concat(this.nameValidator);

  renderFirstName = _.partial(renderTextInput, _, {
    label: {
      path: 'purchase.applicants.form.firstName.label',
    },
    changeHandler: this.props.changeHandler,
    suppressError: true,
    noLabelAnimate: this.props.noLabelAnimate,
    placeholder: this.props.placeholder.firstName,
  });

  renderLastName = _.partial(renderTextInput, _, {
    label: {
      path: 'purchase.applicants.form.lastName.label',
    },
    changeHandler: this.props.changeHandler,
    suppressError: true,
    noLabelAnimate: this.props.noLabelAnimate,
    placeholder: this.props.placeholder.lastName,
  });

  renderFields = (fields: FieldProps) => {
    const [first_fieldName, last_fieldName] = this.props.fieldNames;
    const errorField = _.find(
      // $FlowFixMe: flow is looking for an optional 'check' property
      fields,
      field => field.meta && field.meta.touched && field.meta.error,
    );
    const error = errorField ? errorField.meta.error : null;

    return (
      <div className="input-group-wrapper">
        <div className="row collapse col-half-spacing">
          <div className="columns small-6">
            <RequiredField
              name={first_fieldName}
              component={this.renderFirstName}
              validate={this.firstNameValidators} />
          </div>
          <div className="columns small-6">
            <RequiredField
              name={last_fieldName}
              component={this.renderLastName}
              validate={this.lastNameValidators} />
          </div>
        </div>
        <div className={cx('group-error', { error })}>
          <div className="error-message">{error && <Translate {...error} />}</div>
        </div>
      </div>
    );
  };

  render() {
    return <Fields names={this.props.fieldNames} component={this.renderFields} />;
  }
}

export default FirstAndLastGroup;
